import m from "../../../../geodata/es2015/region/world/oceaniaUltra";
window.am4geodata_region_world_oceaniaUltra = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/oceaniaUltra.js
// module id = null
// module chunks = 